<template>
  <Modal title="統合顧客データの確認" :loading="busy" @close="hide">
    <div class="integration__confirm">
      <p>
        統合元データをもとに、不足している項目に追加データを統合します。<br />
        ※統合元のデータが上書きされることはありません。
      </p>
      <dl>
        <dt>【統合元データ】</dt>
        <dd>{{ integration.name }} <span>様</span></dd>
        <dt>【追加データ】</dt>
        <dd>{{ integration.distName }} <span>様</span></dd>
      </dl>
      <template v-if="integration.duplicateItem && integration.duplicateItem.length">
        <p class="duplication">
          ▼以下の項目を更新します。<br />
          重複している項目は、統合元データを残し、追加データは消去、もしくは統合データに追加データを追記します。<br />
          よろしければ「統合する」をタップしてください。
        </p>
        <ul>
          <li v-for="(item, index) in integration.duplicateItem" :key="index">{{ item }}</li>
        </ul>
      </template>
    </div>
    <template #footer-center>
      <Button @click="hide">キャンセル</Button>
      <Button @click="executeIntegration">統合する</Button>
    </template>
  </Modal>
</template>

<script>
import { mapState } from 'vuex'
import Modal from '@/components/molecules/Modal'
import Button from '@/components/atoms/Button'

/**
 * 顧客統合確認モーダル
 */
export default {
  name: 'IntegrationConfirmModal',
  components: {
    Modal,
    Button,
  },
  computed: {
    ...mapState({
      integration: state => state.customers.integration.detail,
      busy: state => state.customers.integration.busy,
    }),
  },
  methods: {
    executeIntegration() {
      const { id, distId } = this.integration
      this.$emit('executeIntegration', { id, distId })
    },
    hide() {
      this.$emit('hide')
    },
  },
}
</script>

<style lang="postcss" scoped>
.integration__confirm {
  box-sizing: border-box;
  max-height: 480px;
  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
  overflow-y: scroll;
  padding: 16px 24px 40px;

  .duplication {
    padding-left: 1em;
    text-indent: -1em;
  }

  dl {
    align-items: baseline;
    border-bottom: 1px solid var(--very-dark-gray);
    border-top: 1px solid var(--very-dark-gray);
    display: flex;
    flex-wrap: wrap;
    margin: 16px 0 40px;
    padding: 16px 0;
  }

  dt {
    flex-basis: 30%;
  }

  dd {
    flex-basis: 70%;
    font-size: 18px;
    font-weight: 600;

    > span {
      font-size: 13px;
      font-weight: normal;
    }
  }

  ul {
    border-bottom: 1px solid var(--very-dark-gray);
    border-top: 1px solid var(--very-dark-gray);
    margin-top: 16px;
    padding: 16px 0;
  }

  li {
    &::before {
      content: '・';
    }
  }

  .responsive & {
    @media screen and (--sp-modal) {
      dt {
        flex-basis: 40%;
      }

      dd {
        flex-basis: 60%;
      }
    }
  }
}
</style>
